import { InjectionToken } from '@angular/core';

export interface CameraConviteContexto {
  tenant?: string;
  conviteId?: string;
  facialObrigatoria?: boolean;
}

export const CAMERA_CONTEXTO: InjectionToken<CameraConviteContexto> =
  new InjectionToken<CameraConviteContexto>('CameraConviteContexto');
